const horizontalLine = [
  "M13.47 10.53a.84.84 0 0 0-.84.84v1.68H3.37v-1.68a.84.84 0 0 0-1.69 0v2.52a.84.84 0 0 0 .85.85h10.94a.84.84 0 0 0 .85-.85v-2.52a.84.84 0 0 0-.85-.84zM13.47 5.47a.84.84 0 0 1-.84-.84V2.95H3.37v1.68a.84.84 0 0 1-1.69 0V2.11a.84.84 0 0 1 .85-.85h10.94a.84.84 0 0 1 .85.85v2.52a.84.84 0 0 1-.85.84zM0 8a.84.84 0 0 1 .84-.84h14.32a.84.84 0 0 1 0 1.68H.84A.84.84 0 0 1 0 8z"
];
export {
  horizontalLine
};
//# sourceMappingURL=horizontalLine.js.map
